import { type SortDirection } from '../models/sort-direction';

/** Display information for SortDirection enum values. */
export const SORT_DIRECTION_MAP_TO_PRESENTATION: Readonly<Record<SortDirection, string>> = {
  asc: 'ascending',
  desc: 'descending',
};
